export default {
  PARENT: "parent",
  CHILD: "child",
  PARTNER: "partner",
  OTHER: "other"
}
